import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { TableHeadCell, SortDirection } from '@helsenorge/designsystem-react/components/Table';
function reverseSortDirection(sortDir) {
    return sortDir === SortDirection.desc ? SortDirection.asc : SortDirection.desc;
}
export const createHeaders = (columns, colSortDirs, onHeaderClickSortChange, initialSortColumnKey, sortDisabled, sortColumnKey, expandableRow, isTwoDimensional, sortedData) => {
    const headers = [];
    if ((expandableRow || isTwoDimensional) && sortedData && sortedData.length > 0) {
        headers.push(_jsx(TableHeadCell, {}, "expandableHeader"));
    }
    for (let i = 0; i < columns.length; ++i) {
        const column = columns[i];
        const title = column.props.title;
        const altTitle = (_jsxs(_Fragment, { children: [column.props.altTitle, _jsx("br", {})] }));
        const name = column.props.name;
        const headerkey = `header${i}`;
        const sortDirection = colSortDirs[name];
        if (initialSortColumnKey && sortDisabled) {
            headers.push(_jsxs(TableHeadCell, { sortable: false, children: [altTitle, title] }));
        }
        else if (column.props.sortable && sortedData && sortedData.length > 0) {
            headers.push(_jsxs(TableHeadCell, { sortable: true, sortDir: sortDirection, onClick: () => {
                    onHeaderClickSortChange(name, sortDirection ? reverseSortDirection(sortDirection) : 'asc');
                }, children: [altTitle, title] }, name));
        }
        else if (name === sortColumnKey && sortedData && sortedData.length > 0) {
            headers.push(_jsxs(TableHeadCell, { sortable: false, sortDir: sortDirection, children: [altTitle, title] }, name));
        }
        else {
            headers.push(_jsxs(TableHeadCell, { children: [altTitle, title] }, headerkey));
        }
    }
    return headers;
};
